export const Subtitle = ({ children, name }) => {
    const className = name ? `subtitle__${name}` : 'subtitle';
    return <h6 className={className}>{children}</h6>;
};
